"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sbLog = void 0;

var _constants = require("./constants");

var ERROR = _constants.errorLogTypes.ERROR;
/**
 * Logs out a simple console log, prefixed with a SkyBase label, with a color provided by the Log type.
 *
 * @param message - A message to log out to console.
 * @param type - Type of the message, which is used for coloring the label. [ERROR, WARNING, INFO, SUCCESS]
 */

var sbLog = function sbLog(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ERROR;
  console.log("%c[SkyBase ".concat(type, "]"), _constants.errorLogStyles[type], message);
};

exports.sbLog = sbLog;
//# sourceMappingURL=sb-log.js.map